import { Injectable } from '@angular/core';
import * as moment from "moment";
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalConstants } from 'src/app/shared/global-constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  Moderator = GlobalConstants.Moderator;
  Publisher = GlobalConstants.Publisher;

  constructor(private http: HttpClient) {  }
  itemValue = new BehaviorSubject(this.storageItems);

  set storageItems(value:any) {
    this.itemValue.next(value); // this will make sure to tell every subscriber about the change.
    localStorage.setItem('UserId', value.UserId);
    localStorage.setItem("FirstName",value.FirstName);
    localStorage.setItem("LastName", value.LastName);
    localStorage.setItem("RoleName",value.RoleName);
    localStorage.setItem("EmailAddress", value.EmailAddress);
  }

  get storageItems() {
    return {
      UserId:localStorage.getItem('UserId'),
      FirstName:localStorage.getItem('FirstName'),
      LastName:localStorage.getItem('LastName'),
      RoleName:localStorage.getItem('RoleName'),
      EmailAddress:localStorage.getItem('EmailAddress')
    }
  }

  setSession(authResult:any){
  const expiresAt = moment().add(authResult.expiresIn,'second');
  localStorage.setItem('accessToken', authResult.accessToken);
  localStorage.setItem("expiresAt", JSON.stringify(expiresAt.valueOf()) );
  localStorage.setItem("source", authResult.source);
}
setUserSession(UserId,FirstName,LastName,RoleName,EmailAddress){
  this.storageItems = {
    UserId:UserId,
    FirstName:FirstName,
    LastName:LastName,
    RoleName:RoleName,
    EmailAddress:EmailAddress
  };
}
setUserSessionNull(){

  localStorage.setItem('UserId',null );
  localStorage.setItem("FirstName",null);
  localStorage.setItem("LastName",null );
  localStorage.setItem("RoleName",null );
  localStorage.setItem("EmailAddress",null );
}
setPreviousRoute(routeName:string){
  localStorage.setItem('route',routeName );
}
setAuthToken(authResult:any){
  localStorage.setItem('authToken', authResult.token);
  localStorage.setItem("refreshToken", authResult.refresh_token );
}

destroyUserSession(){
  localStorage.removeItem('UserId');
  localStorage.removeItem("FirstName");
  localStorage.removeItem("LastName");
  localStorage.removeItem("RoleName");
  localStorage.removeItem("EmailAddress");

}
logout() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("expiresAt");
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("route");
}

public isLoggedIn() {
    return moment().isBefore(this.getExpiration());
}

isLoggedOut() {
    return !this.isLoggedIn();
}

getExpiration() {
    const expiration =localStorage.getItem("expiresAt");
    if(expiration)
    return moment(JSON.parse(expiration));
    else
    return null
}
  checkRoleForNavList(): boolean {
    let role = localStorage.getItem("RoleName");

    if(role == this.Publisher || role == this.Moderator){
     return true;
    }
    else{
      return false;
    }
  }
}
